import React from 'react'
import { NavLink } from 'react-router-dom';
import './Header.css'
function Header() {
    return (
        <div>
            <header className="header" >
                <div className="topbar">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-12">
                                <ul className="top-link">
                                    <li><i className="fa fa-phone" style={{ color: '#1A76D1' }}></i>+91 805 131 6666</li>
                                    <li><i className="fa fa-envelope" style={{ color: '#1A76D1' }}></i> support@webnettechnologies.org</li>
                                </ul>
                            </div>
                            <div className="col-lg-6 col-md-6 col-12">
                                <ul className="top-contact">
                                    <li><a href="https://www.facebook.com/WebnetTechnologiespatna" target='blank' aria-label="Facebook"><i className="icofont-facebook"></i></a></li>
                                    <li><a href="https://twitter.com/WebnetTechnologies" target='blank' aria-label="Twitter"><i class="fa-brands fa-x-twitter"></i></a></li>
                                    <li><a href="https://www.instagram.com/webnettechnologies/" target='blank' aria-label="instagram"><i className="icofont-instagram"></i></a></li>
                                    <li><a href="https://www.linkedin.com/in/webnet-technologies-a451ab292/?originalSubdomain=in:" target='blank' aria-label="linkedin"><i className="icofont-linkedin"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="header-inner">
                    <div className="container">
                        <div className="inner">
                            <div className="row">
                                <div className="col-lg-2 col-md-3 col-12">
                                    <div className="logo">

                                        <NavLink to='/'><img src="img/Webnet-Logo.png" alt="#" className='img-logo' /></NavLink>

                                    </div>
                                    <div className="mobile-nav"></div>
                                </div>
                                <div className="col-lg-8 col-md-9 col-12">

                                    <div className="main-menu">
                                        <nav className="navigation">
                                            <ul className="nav menu">
                                                <li><NavLink to='/'>Home</NavLink></li>

                                                <li>
                                                    <button type="button" className="dropdown-toggle">About Us</button>
                                                    <ul className="dropdown">
                                                        <li><NavLink to='/overview'>Company Profile</NavLink></li>
                                                        <li><NavLink to='/mission'>Mission / Vision</NavLink></li>
                                                        <li><NavLink to='/Meetourteam'>Meet Our Team</NavLink></li>
                                                    </ul>
                                                </li>

                                                <li>
                                                    <button type="button" className="dropdown-toggle">Service </button>
                                                    <ul className="dropdown">
                                                        <li><NavLink to='/clinicmanagement'>Clinic Management</NavLink></li>
                                                        <li><NavLink to='/hospitalmanagement'>Hospital Management</NavLink></li>
                                                        <li><NavLink to='/solutionforpharma'>Solution for Pharma Companies</NavLink></li>
                                                        <li><NavLink to='/patientapp'>Patient App</NavLink></li>
                                                        <li><NavLink to='/doctorsapp'>Doctors App</NavLink></li>
                                                    </ul>
                                                </li>

                                                <li>
                                                    <button type="button" className="dropdown-toggle">Resources </button>
                                                    <ul className="dropdown">
                                                        <li><NavLink to='/blogs'>Blogs</NavLink></li>
                                                        <li><NavLink to='/faqs'>FAQs</NavLink></li>
                                                    </ul>
                                                </li>

                                                <li>
                                                    <button type="button" className="dropdown-toggle">Pricing </button>
                                                    <ul className="dropdown">
                                                        <li><NavLink to='/Clinicsolution'>Hospital / Clinic Solution</NavLink></li>
                                                        <li><NavLink to='/product'>Other Product</NavLink></li>
                                                    </ul>
                                                </li>

                                                {/* <li><NavLink to='/portfolio'>Gallery</NavLink></li> */}
                                                <li><NavLink to='/contactus'>Contact Us</NavLink></li>
                                            </ul>
                                        </nav>
                                    </div>

                                </div>
                                <div className="col-lg-2 col-12">
                                    <div className="get-quote">
                                        <NavLink to='/bookingfordemo' rel="noreferrer" className="btn btn-primary">Book Appointment</NavLink>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="icon-bar">
                    <a href="https://wa.me/+91 8051316666" target='blank' class="whatsapp" title="Chat on WhatsApp">
                        <i class="fab fa-whatsapp fa-beat"></i>
                    </a>

                    <a href="tel:+91 8051316666" class="phone" target='blank' title="Call Us">
                        <i class="fas fa-phone fa-beat"></i>
                    </a>

                    <a href="mailto:support@webnettechnologies.org" target='blank' class="email" title="Email Us">
                        <i class="fas fa-envelope fa-beat"></i>
                    </a>
                </div>
            </header>
        </div>
    )
}

export default Header